module.exports = __webpack_public_path__ + "static/media/image-36.2e41109d.png";